import React from 'react';
import gql from 'graphql-tag';
import { ApolloProvider, Query, Mutation } from 'react-apollo';
import client from '../lib/apolloClient';
import PersonalFinancialReadiness from '../components/PersonalFinancialReadiness/PersonalFinancialReadiness';

const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    getCurrentUser {
      id
      readiness_goal_type
      readiness_goal_lump_sum
      readiness_goal_annual_income
      readiness_withdrawal_rate
      readiness_current_investable_assets
      readiness_include_illiquid
      readiness_gap_value
      readiness_gap_zone
      readiness_percent_to_goal
      readiness_last_updated_at
    }
  }
`;

const UPSERT_READINESS = gql`
  mutation UpsertPersonalFinancialReadiness(
    $goal_type: String
    $goal_lump_sum: Float
    $annual_income: Float
    $withdrawal_rate: Float
    $current_investable_assets: Float
    $include_illiquid: Boolean
  ) {
    upsertPersonalFinancialReadiness(
      goal_type: $goal_type
      goal_lump_sum: $goal_lump_sum
      annual_income: $annual_income
      withdrawal_rate: $withdrawal_rate
      current_investable_assets: $current_investable_assets
      include_illiquid: $include_illiquid
    ) {
      user {
        id
        readiness_goal_type
        readiness_goal_lump_sum
        readiness_goal_annual_income
        readiness_withdrawal_rate
        readiness_current_investable_assets
        readiness_include_illiquid
        readiness_gap_value
        readiness_gap_zone
        readiness_percent_to_goal
        readiness_last_updated_at
      }
      errors
    }
  }
`;

const SEND_ANALYTICS_EVENT = gql`
  mutation SendAnalyticsEvent($event_name: String!, $custom_props: JsonType) {
    sendAnalyticsEvent(event_name: $event_name, custom_props: $custom_props)
  }
`;

class PersonalFinancialReadinessContainer extends React.Component {
  render() {
    return (
      <ApolloProvider client={client}>
      <Query query={GET_CURRENT_USER} fetchPolicy="cache-and-network">
        {({ data, loading, error, refetch }) => {
          if (loading) return <div>Loading...</div>;
          if (error) return <div>Error loading data</div>;
          const currentUser = (data && data.getCurrentUser) || null;
          return (
            <Mutation mutation={SEND_ANALYTICS_EVENT}>
              {(sendEvent) => (
                <Mutation mutation={UPSERT_READINESS}>
                  {(upsert, { loading: saving }) => {
                    const handleSave = async (values) => {
                      await upsert({ variables: values });
                    };
                    const track = async (name, props) => {
                      try { await sendEvent({ variables: { event_name: name, custom_props: props } }); } catch(e) {}
                    };
                    return (
                      <PersonalFinancialReadiness user={currentUser} onSave={handleSave} saving={saving} track={track} />
                    );
                  }}
                </Mutation>
              )}
            </Mutation>
          );
        }}
      </Query>
      </ApolloProvider>
    );
  }
}

export default PersonalFinancialReadinessContainer;


